// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.production.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentModel } from './environment.model';

export const environment: EnvironmentModel = {
  production: true,
  scopes: ['openid', 'offline_access', 'https://monsterenergydev.onmicrosoft.com/retailer-api/AccessAdminApi'],
  b2cTenant: 'monsterenergydev',
  b2cClientId: 'f635781e-c8a4-4efe-a3c7-4e0f18a448a8',
  partUrlBackendAPI: 'dev',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
